// Catalogue prices are stored in USD; JOD/EUR are display conversions.
// JOD rate must match JOD_RATE in backend/payments/views.py (CliQ charges in JOD).
export const CURRENCY_RATES = {
  USD: { symbol: '$', rate: 1 },
  EUR: { symbol: '€', rate: 0.92 },
  JOD: { symbol: 'JD', rate: 0.71 },
};

// USD price of each DLR extra game; mirrors calculate_game_extras_price on the backend.
export const DLR_EXTRA_PRICES = {
  MIC: 14,
  SKT: 14,
  MEK: 10,
  RMS: 10,
  ROT: 14,
  OWT: 14,
  PPT: 10,
};

// Convert a USD catalogue price into `currency` and format it.
export const convertPrice = (priceUSD, currency) => {
  const { symbol, rate } = CURRENCY_RATES[currency] || CURRENCY_RATES.USD;
  return `${symbol}${(parseFloat(priceUSD || 0) * rate).toFixed(2)}`;
};

// Format an amount that was already charged in `currencyCode` (e.g. a purchase record).
export const formatAmount = (amount, currencyCode = 'USD') => {
  const code = (currencyCode || 'USD').toUpperCase();
  const symbol = CURRENCY_RATES[code]?.symbol;
  const value = parseFloat(amount || 0).toFixed(2);
  return symbol ? `${symbol}${value}` : `${value} ${code}`;
};
